import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import Select from "react-select";
import axios from "axios";

const AddUsers = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [rolesData, setRolesData] = useState([]);
  const [stateDrp, setStateDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    email:"",
    password:"",
    password_confirmation:"",
    city_id: "",
    state_id: "",
    role_id: "",
    address: "",
    pincode: "",
    gst_no: "",
    country_id: 101,
    contact_no:"",
  });

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
    }),
  };

  const resetForm = () => {
    setFormValue({
      id: null,
      name: "",
      email:"",
      password:"",
      password_confirmation:"",
      city_id: "",
      state_id: "",
      role_id: "",
      address: "",
      pincode: "",
      gst_no: "",
      country_id: 101,
      contact_no:""
    });
  };

  const getStateDrpData = () => {
    axios
      .post(API_URL.STATE_LIST, { country_id: 101 })
      .then((res) => {
        if (res.data.status === 1) {
          let cd = res.data.data.map((caw) => {
            return {
              label: caw.name,
              value: caw.id,
            };
          });
          setStateDrpData(cd);
        }
      });
  };

  const getRoles = () => {
    axios
      .post(API_URL.USERS_ROLES, {})
      .then((res) => {
        if (res.data.status === 1) {
          let cd = res.data.data.map((caw) => {
            return {
              label: caw.name,
              value: caw.id,
            };
          });
          setRolesData(cd);
        }
      });
  };

  const getCityDrpData = () => {
    axios
      .post(API_URL.CITY_LIST, {state_id: formValue.state_id})
      .then((res) => {
        if (res.data.status === 1) {
          let cd = res.data.data.map((caw) => {
            return {
              label: caw.name,
              value: caw.id,
            };
          });
          setCityDrpData(cd);
        }
      });
  };

  const onEdit = () => {
    axios.post(API_URL.USERS_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          city_id: res.data.data.city_id ? res.data.data.city_id : "",
          country_id: res.data.data.country_id ? res.data.data.country_id : 101,
          state_id: res.data.data.state_id ? res.data.data.state_id : "",
          role_id: res.data.data.role_id ? res.data.data.role_id : "",
          address: res.data.data.address ? res.data.data.address : "",
          pincode: res.data.data.pincode ? res.data.data.pincode : "",
          gst_no: res.data.data.gst_no ? res.data.data.gst_no : "",
          email: res.data.data.email ? res.data.data.email : "",
          contact_no: res.data.data.contact_no ? res.data.data.contact_no : "",
          password:"",
          password_confirmation:"",
        });
      }
    });
  };

  const saveItem = () => {
    if (
      formValue.name &&
      formValue.email &&
      formValue.city_id &&
      formValue.state_id &&
      formValue.role_id &&
      formValue.contact_no &&
      (id ? true : formValue.password) &&
      (id ? true : (formValue.password === formValue.password_confirmation))
    ) {
      const pUrl = id ? API_URL.USERS_UPDATE : API_URL.USERS_SAVE;
      axios.post(pUrl, formValue).then((res) => {
        if (res.data.status === 1) {
          if (id) {
            toast.success("Updated", { autoClose: 3000 });
          } else {
            toast.success("Saved", { autoClose: 3000 });
          }
          setTimeout(() => {
            navigate("/users", { replace: true });
          }, 100);
        } else {
          toast.error(res.data.data, { autoClose: 3000 });
        }
      });
    } else {
      toast.error("Please enter valid details")
    }
  };

  const isValidForm = () => {
    return (
      formValue.name &&
      formValue.email &&
      formValue.city_id &&
      formValue.state_id &&
      formValue.role_id &&
      formValue.contact_no &&
      (id ? true : formValue.password) &&
      (id ? true : (formValue.password === formValue.password_confirmation))
    );
  };

  const setFormData = (name, value) => {
    setFormValue({ ...formValue, [name]: value });
  };

  useEffect(() => {
    getCityDrpData();
  }, [formValue.state_id]);

  useEffect(() => {
    id && onEdit();
  }, [id]);
 
  useEffect(() => {
    getRoles();
    getStateDrpData();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
            <h1>{id ? "Edit" : "Add"} User</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/users"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Role<span className="text-danger">*</span></label>
                      <Select
                        options={rolesData}
                        value={rolesData.find((r) => r.value == formValue.role_id)}
                        styles={styles}
                        onChange={(e) => setFormValue({ ...formValue,role_id: e.value})}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        value={formValue.name}
                        onChange={(e) => setFormData("name", e.target.value)}
                        className="form-control"
                        placeholder="Enter Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Email<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        value={formValue.email}
                        onChange={(e) => setFormData("email", e.target.value)}
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Password<span className="text-danger">*</span></label>
                      <input
                        type="password"
                        value={formValue.password}
                        onChange={(e) => setFormData("password", e.target.value)}
                        className="form-control"
                        placeholder="Password"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Confirm Password<span className="text-danger">*</span></label>
                      <input
                        type="password"
                        value={formValue.password_confirmation}
                        onChange={(e) => setFormData("password_confirmation", e.target.value)}
                        className="form-control"
                        placeholder="Confirm Password"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Contact Number<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        value={formValue.contact_no}
                        onChange={(e) => setFormData("contact_no", e.target.value)}
                        className="form-control"
                        placeholder="Contact Number"
                      />
                    </div>
                  </div>                  
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>State<span className="text-danger">*</span></label>
                      <Select
                        options={stateDrp}
                        value={stateDrp.find((r) => r.value == formValue.state_id)}
                        styles={styles}
                        onChange={(e) => setFormValue({ ...formValue,state_id: e.value})}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label htmlFor="City">City<span className="text-danger">*</span></label>
                      <Select
                        options={cityDrp}
                        value={cityDrp.find((r) => r.value == formValue.city_id)}
                        styles={styles}
                        onChange={(e) =>
                          setFormValue({ ...formValue, city_id: e.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Address</label>
                      <input
                        type="text"
                        value={formValue.address}
                        onChange={(e) => setFormData("address", e.target.value)}
                        className="form-control"
                        placeholder="Address"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Pincode</label>
                      <input
                        type="text"
                        value={formValue.pincode}
                        onChange={(e) => setFormData("pincode", e.target.value)}
                        className="form-control"
                        placeholder="Pincode"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>GST Number</label>
                      <input
                        type="text"
                        value={formValue.gst_no}
                        onChange={(e) => setFormData("gst_no", e.target.value)}
                        className="form-control"
                        placeholder="GST Number"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <div className="form-group text-right">
                      <button
                        type="submit"
                        onClick={saveItem}
                        disabled={!isValidForm()}
                        className="btn btn-primary"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUsers;
